import React from 'react'
import PropTypes from 'prop-types'
import { colors } from '@lmc/common/constants'
import { Glyph } from '../../../../../LEGACY/Glyph'
import { Text } from '@lmc/ui-kit'


const ReasonCode = ({ round }) => {
  if (round.taken) {
    return <Glyph color="success" name="check" />
  }

  return (
    <Text style={styles.reasonCode} as="h5">
      {round.reasonCode}
    </Text>
  )
}

export default function PRNCell(props) {
  const { prnRounds } = props
  return (
    <div style={styles.prnCellContainer}>
      {prnRounds.map((round) => (
        <ReasonCode key={round.id} round={round} />
      ))}
    </div>
  )
}

PRNCell.propTypes = {
  prnRounds: PropTypes.array.isRequired,
}

const styles = {
  addText: {
    color: colors.successgreen,
    fontSize: 16,
    fontWeight: 700,
    lineHeight: '22px',
    margin: '2px 0px',
  },
  checkIcon: {
    color: colors.successgreen,
    fontSize: 16,
    margin: '2px 0px',
  },
  prnCellContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  reasonCode: {
    color: colors.red,
    lineHeight: '22px',
  },
}
